import { render, staticRenderFns } from "./notifications-item-chat-response.vue?vue&type=template&id=20dea6b8&scoped=true"
import script from "./notifications-item-chat-response.vue?vue&type=script&lang=js"
export * from "./notifications-item-chat-response.vue?vue&type=script&lang=js"
import style0 from "./notifications-item-chat-response.vue?vue&type=style&index=0&id=20dea6b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dea6b8",
  null
  
)

export default component.exports